
/* global FastClick, tns, Cookies */

window.site = window.site || {};
site.cookies = {
    variables: {
      cookieName: 'VanillaCookies',
      usersPreferences: undefined,
      newPreferences: {
        DateInitialised: new Date(),
        DateLastUpdated: new Date(),
        AllowPerformance: false
      }
    },
  
    elements: {
      $cookieNotice: $('#cookieNotice'),
      $cookiePreferencesModal: $('#cookiePreferencesModal'),
      $btnsAccept: $('#cookiesAcceptAll,#cookieNoticeAccept'),
      $btnSavePreferences: $('#cookiesSavePreferences'),
      $chkPerformance: $('#chkCookiePref__Performance')
    },

    init: function () {
        // get users preferences
        site.cookies.variables.usersPreferences = Cookies.getJSON(site.cookies.variables.cookieName);
  
        // display cookie notice
        if (typeof site.cookies.variables.usersPreferences === 'undefined') {
          site.cookies.elements.$cookieNotice.show();
        }
  
        // set users preferences
        if (typeof site.cookies.variables.usersPreferences !== 'undefined') {
          site.cookies.elements.$chkPerformance.attr('checked', site.cookies.variables.usersPreferences.AllowPerformance);
  
          site.cookies.functions.switchCheckboxLabel(site.cookies.elements.$chkPerformance);
        }
  
        // make sure links to modal have the data-toggle attribute (no way to manage this in Umbraco)
        var $cookieModalAnchors = $('a[href="#cookiePreferencesModal"]');
        if ($cookieModalAnchors.length > 0) {
          $.each($cookieModalAnchors, function (key, value) {
            if (!value.hasAttribute('data-toggle')) {
              value.setAttribute('data-toggle', 'modal');
            }
          });
        }
  
        site.cookies.elements.$btnsAccept.click(function () {
          site.cookies.functions.acceptAllCookies();
        });
  
        site.cookies.elements.$btnSavePreferences.click(function () {
          site.cookies.functions.savePreferences();
        });
  
        site.cookies.elements.$chkPerformance.change(function () {
          site.cookies.functions.switchCheckboxLabel($(this));
        });
      },
  
    functions: {  
      switchCheckboxLabel: function ($checkbox) {
        // update checkbox label text
        $('.custom-control-label', $checkbox.parent()).text($checkbox.is(':checked') ? 'On' : 'Off');
      },
  
      acceptAllCookies: function () {
        // make sure all checkboxes checked
        if (!site.cookies.elements.$chkPerformance.is(':checked')) {
          site.cookies.elements.$chkPerformance.click();
        }
  
        // save preferences
        setTimeout(function () {
          site.cookies.functions.savePreferences();
        }, 250);
      },
  
      savePreferences: function () {
        var updatedPreferences;
  
        if (typeof site.cookies.variables.usersPreferences !== 'undefined') {
          updatedPreferences = site.cookies.variables.usersPreferences;
        } else {
          updatedPreferences = site.cookies.variables.newPreferences;
        }
  
        // update preferences based on checkboxes
        updatedPreferences.AllowPerformance = site.cookies.elements.$chkPerformance.is(':checked');
        updatedPreferences.DateLastUpdated = new Date();
  
        // set cookies
        site.cookies.functions.setPreferences(updatedPreferences);
  
        // hide cookie notice and modal
        site.cookies.functions.hideCookieNotice();
        site.cookies.functions.hideCookiePreferencesModal();
      },
  
      setPreferences: function (settings) {
        Cookies.set(site.cookies.variables.cookieName, settings, { expires: 365, secure: true });
      },
  
      hideCookieNotice: function () {
        if (site.cookies.elements.$cookieNotice.is(':visible')) {
          site.cookies.elements.$cookieNotice.hide();
        }
      },
  
      hideCookiePreferencesModal: function () {
        if (site.cookies.elements.$cookiePreferencesModal.is(':visible')) {
          site.cookies.elements.$cookiePreferencesModal.modal('hide');
        }
      }
    }
  };

(function() {
	// Mobile fast click to remove tap delay
	// https://github.com/ftlabs/fastclick
	if ('addEventListener' in document) {
		document.addEventListener('DOMContentLoaded', function() {
			FastClick.attach(document.body);
		}, false);
    }

    window.site.cookies.init();
    
	var sliders = document.querySelectorAll('.tiny-slider');
	for (var i = 0; i < sliders.length; i++) {
		tns({
			container: sliders[i],
			items: 1.2,
			controls: false,
			controlsText: ['<span class="icon-arrow-left" aria-hidden="true"></span>', '<span class="icon-arrow" aria-hidden="true"></span>'],
			nav: false,
			loop: false,
			responsive: {
				640: {
					items: 2,
					controls: true,
					edgePadding: 60
				},
				900: {
					items: 3,
					mouseDrag: true
				},
				1120: {
					edgePadding: 0
				}
			}
		});
	}
})();

(function () {
    if (window.NodeList && !NodeList.prototype.forEach) {
        NodeList.prototype.forEach = function (callback, thisArg) {
            thisArg = thisArg || window;
            for (var i = 0; i < this.length; i++) {
                callback.call(thisArg, this[i], i, this);
            }
        };
    }

    if (!String.prototype.includes) {
        String.prototype.includes = function (search, start) {
            'use strict';

            if (search instanceof RegExp) {
                throw TypeError('first argument must not be a RegExp');
            }
            if (start === undefined) { start = 0; }
            return this.indexOf(search, start) !== -1;
        };
    }

    var dropdownToggles = document.querySelectorAll('.dropdown-container');
    var dropdownBackground = document.querySelector('.dropdown-background');
    var mainNav = document.getElementById('toptag');
    var mainNavHeight = mainNav.clientHeight;
    var secondaryNav = document.getElementById('secondary-nav');

    var navFixed = mainNav.classList.contains('fixed-top');
    var hasHeroImage = secondaryNav.classList.contains('socials-dark--contains-hero');
    
    dropdownToggles.forEach(function (dropdown) {
        var dropdownParent = dropdown.querySelector('.dropdown-parent');
        var dropdownBox = dropdown.querySelector('.dropdown-children');
        dropdownParent.addEventListener('click', function () {

            var observer = new MutationObserver(function (mutations, observer) {
                mutations.forEach(function (mutation) {
                    if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                        if (hasClass(mutation.target, 'show') && window.innerWidth > 880) {
                            setNavBackgroundHeight(dropdownBox, dropdownBackground);
                            setDropdownBoxMargin(dropdownParent, dropdownBox, mainNav);
                        } else {
                            dropdownBackground.style.removeProperty('height');
                            dropdownBox.style.removeProperty('margin-top');
                            observer.disconnect();
                        }
                    }
                });
            });
            observer.observe(dropdownBox, { attributes: true });
        });
    });
    
    addEventListener("resize", function() {
        var recalculatedMainNavHeight = document.getElementById('toptag').clientHeight;

        var openDropdownBox = document.querySelector('.dropdown-children.show');
        
        if (window.innerWidth < 880) {
            openDropdownBox.classList.remove('show');
            openDropdownBox.setAttribute('style', 'margin-top:0;');
            dropdownBackground.setAttribute('style', 'height:0;');
            
            return;
        }
        
        if (recalculatedMainNavHeight !== mainNavHeight) {
            mainNavHeight = recalculatedMainNavHeight;
            var dropdownParent = openDropdownBox.parentElement.querySelector('.dropdown-parent')
            
            if (openDropdownBox) {
                setDropdownBoxMargin(dropdownParent, openDropdownBox, mainNav);
            }   
        }
    });

    if (navFixed) {
        addEventListener("scroll", function () {
            var openDropdownBox = document.querySelector('.dropdown-children.show');
            if (openDropdownBox && window.innerWidth > 880) {
                var dropdownParent = openDropdownBox.parentElement.querySelector('.dropdown-parent')

                setDropdownBoxMargin(dropdownParent, openDropdownBox, mainNav);
                setNavBackgroundHeight(openDropdownBox, dropdownBackground);
            }
        });
    }
    
    function setDropdownBoxMargin(dropdownParent, dropdownBox, mainNav) {
        var mainNavHeight = mainNav.clientHeight;

        var topOffset = dropdownParent.getBoundingClientRect().top;
        
        var styleAttributes = 'margin-top: ' + (((mainNavHeight - topOffset + 4))) + 'px;';

        dropdownBox.setAttribute('style', styleAttributes)
    }

    function setNavBackgroundHeight(dropdownBox, dropdownBackground) {
        var height = dropdownBox.clientHeight;
        
        var styles = 'height: ' + height + 'px;';
        
        if (!hasHeroImage) {
            var offset = secondaryNav.clientHeight;
            
            styles += 'margin-top: ' + -offset + 'px;';
        }
        
        dropdownBackground.setAttribute('style', styles);
    }
    
    function hasClass(element, className) {
        return new RegExp('(^| )' + className + '( |$)', 'gi').test(element.className);
    }

})();

(function () {
    var $cookieNotice = $('#cookieNotice');
    var $acceptCookies = $('#cookieNoticeAccept');

    if ($cookieNotice.attr('style') !== 'display: none;') {
        $('html').addClass('cookies-modal-present');
    }

    $acceptCookies.click(function () {
        setTimeout(function () {
            $('html').removeClass('cookies-modal-present');
        }, 300);
    });
})();

(function(){
    $('#carousel').carousel('cycle',{
        interval: 3000,
        
    })
})();